import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-heading _mb-3" }
const _hoisted_2 = { class: "gfu-subheading gfu-subheading--wizard _mb-6" }
const _hoisted_3 = { class: "_mb-6 gfu-box gfu-box--flat gfu-box--nested" }
const _hoisted_4 = { class: "gfu-heading" }
const _hoisted_5 = { class: "_ml-6" }
const _hoisted_6 = { class: "gfu-box gfu-box--flat gfu-box--nested" }
const _hoisted_7 = { class: "gfu-heading" }
const _hoisted_8 = { class: "_ml-6" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_toggle_field = _resolveComponent("toggle-field")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.Resources.Cookies.SettingsBoxHeader), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.Resources.Cookies.SettingsBoxParagraph), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_toggle_field, {
        modelValue: $data.model.technicalCookiesAccepted,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.technicalCookiesAccepted) = $event)),
        type: "switch",
        disabled: true,
        "data-qa": "TechnicalCookiesAccepted"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.Resources.Cookies.TechnicalCookiesHeader), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"]),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.Resources.Cookies.TechnicalCookiesParagraph), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_toggle_field, {
        modelValue: $data.model.analyticCookiesAccepted,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.model.analyticCookiesAccepted) = $event)),
        type: "switch",
        onChange: $options.updateAnalyticsCookie,
        "data-qa": "AnalyticCookiePolicyAccepted"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.Resources.Cookies.AnalyticCookiesHeader), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue", "onChange"]),
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.Resources.Cookies.AnalyticCookiesParagraph), 1 /* TEXT */)
    ]),
    _createVNode(_component_progress_overlay, {
      visible: _ctx.isProcessing,
      sticky: true
    }, null, 8 /* PROPS */, ["visible"])
  ]))
}